import { makeTable } from "../utils/tables";

export const pastAllegiances = makeTable("pastAllegiances", [
  {
    name: "An Idea",
    description:
      "You held some value — faith, science or something else — higher than war and strife. You made compromises but kept away from fighting.",
  },
  {
    name: "Family",
    description:
      "You stayed with family and kin, defending your turf with tooth and claw.",
  },
  {
    name: "Winning Side",
    description:
      "You happened to side with the winners, but in the end, did you really win?",
  },
  {
    name: "Losing Side",
    description:
      "Working for the losing side, death followed in your steps. You survived, but at great cost.",
  },
  {
    name: "The Contract",
    description:
      "As an opportunist, you swore allegiance to those who paid best.",
  },
  {
    name: "None",
    description:
      "You sided only with yourself and avoided the war as well as you could.",
  },
]);
